import React from "react";

function AgencyRow({ agency, rank }) {
  return (
    <tr>
      <td>{rank}</td>
      <td>
        <a href={`/companies/${agency.company_slug}`}>{agency.company_name}</a>
      </td>
      <td>Speed points: {agency.pitch_speed_points || 0}</td>
      <td>Outcome points: {agency.conversation_outcome_points + agency.direct_media_reply_points}</td>
      <td>{agency.bad_behavior_points}</td>
      <td>{agency.total_points}</td>
    </tr>
  );
}

export default AgencyRow;
